import { FeatureIconName } from 'libs/icons';
import { useTranslation } from 'libs/translations';

import { FirstlineDataHeader } from './FirstlineDataHeader';

export function TPRegistrationsHeader(props: { readonly iconOnly?: boolean }) {
  const { t } = useTranslation();

  return (
    <FirstlineDataHeader
      icon={FeatureIconName.Registrations}
      text={t('Team Partner registrations')}
      onlyIcon={props.iconOnly}
    />
  );
}

export function MyCustomerRegistrationsHeader(props: {
  readonly iconOnly?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <FirstlineDataHeader
      icon={FeatureIconName.Registrations}
      text={t('My customers')}
      onlyIcon={props.iconOnly}
    />
  );
}

export function MyTPRegistrationsHeader(props: {
  readonly iconOnly?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <FirstlineDataHeader
      icon={FeatureIconName.Registrations}
      text={t('My TPs')}
      onlyIcon={props.iconOnly}
    />
  );
}

export function CustomerRegistrationsHeader(props: {
  readonly iconOnly?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <FirstlineDataHeader
      icon={FeatureIconName.Registrations}
      text={t('Customer registrations')}
      onlyIcon={props.iconOnly}
    />
  );
}

export function QuickstartRegistrationsHeader(props: {
  readonly iconOnly?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <FirstlineDataHeader
      icon={FeatureIconName.Registrations}
      text={t('Quickstarter registrations')}
      onlyIcon={props.iconOnly}
    />
  );
}
